<template>
  <div class="mt-0 sm:mt-4"> 
    <div class="text-center text-black py-4 font4">
      Enter your 13-digit contract number
    </div>
    <div class="flex flex-col sm:flex-row w-full space-y-2 sm:space-y-0 sm:space-x-2 px-4 mb-4">
      <v-text-field
        class="w-full sm:w-auto"
        maxlength="2"
        outlined
        :rules="[rules.required, rules.min, rules.max]"
        hint="first two digits"
        counter
        v-model="co_code"
      ></v-text-field>

      <div class="w-full">
        <v-text-field
          class="w-full"
          maxlength="11"
          outlined
          :rules="[rules2.required, rules2.min, rules2.max]"
          hint="11 digits"
          counter
          v-model="contractNumber"
        ></v-text-field>
      </div>
    </div>
    <!-- SIGNUP BUTTON  -->
    <div class="text-center pb-4">
      <div>
        <button
          class="
            px-4
            hover:bg-gray-500
            font-noto-sans
            w-[200px]
            rounded-md
            text-black
            bg-gray-400
            h-[40px]
          "
          @click="
            $emit('submitContractNumber', {
              contractNumber: contractNumber,
              co_code: co_code,
            })
          "
        >
          Sign Up
        </button>
      </div>
      <div class="text-xs py-1">
        {{ subtitle2 }}
      </div>

      <div>
        <button
          class="
          hover:bg-gray-500
            text-black
            font-noto-sans
            w-[200px]
            rounded-md
            bg-gray-400
            h-[40px]
          "
          @click="$emit('cancelContractNumber')"
        >
          Cancel Sign Up
        </button>
      </div>
      <div class="text-black font-noto-sans mt-4">
        Please ensure to update your BIS
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => !v || v.length >= 2 || "Min 2 characters",
        max: (v) => !v || v.length <= 2 || "Max 2 characters",
      },
      rules2: {
        required: (value) => !!value || "Required.",
        min: (v) => !v || v.length >= 11 || "Min 11 characters",
        max: (v) => !v || v.length <= 11 || "Max 11 characters",
      },

      subtitle2: null,
      co_code: null,
      contractNumber: null,
    };
  },
};
</script>
